import PosActions from '../../../actions/PosActions';
import NotificationActions from '../../../actions/NotificationActions';
import UserActions from '../../../actions/UserActions';

import PosStore from '../../../stores/PosStore';
import UserStore from '../../../stores/UserStore';
// import GuestListStore from '../../stores/GuestListStore';
import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as AuthEndPoints } from '../../../constants/AuthConstants';
import { endPoints as UserEndPoints } from '../../../constants/UserConstants';

import PageHeader from '../../form/layout/PageHeader.react';
import PageRow from '../../form/layout/PageRow.react';

// import DD from '../form/dropdown/DD.react';
import DDBoolean from '../../form/dropdown/DDBoolean.react';
import Input from '../../form/input/Input.react';

class GLSettingsVG extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading : true,
            isSetUp : false,
            isEnabled : true,
            name : '',
            username : '',
            password : '',
            managerPin : '',
            isValid : false,

            override :false,
        };

        this.onUserStoreChange = this.onUserStoreChange.bind(this);
        this.onPosStoreChange = this.onPosStoreChange.bind(this);
        this.getDPHUserCredentials = this.getDPHUserCredentials.bind(this);
        this.update = this.update.bind(this);
        this.override = this.override.bind(this);
        this.disableOverride = this.disableOverride.bind(this);
    }

    // componentWillMount() {
        // GuestListStore.addChangeListener(this.onGuestListStoreChange);
    // }

    componentDidMount() {
        PosStore.addChangeListener(this.onPosStoreChange);
        UserStore.addChangeListener(this.onUserStoreChange);

        this.getDPHUserCredentials();
    }

    componentWillUnmount() {
        PosStore.removeChangeListener(this.onPosStoreChange);
        UserStore.removeChangeListener(this.onUserStoreChange);
    }

    onPosStoreChange() {
        if (this.state.override && !PosStore.getState().overrideDPH)
            NotificationActions.alert('Override disabled');
        else if (!this.state.override && PosStore.getState().overrideDPH)
            NotificationActions.alert('Override DPH Successful')

        this.setState({ override : PosStore.getState().overrideDPH });
    }

    onUserStoreChange() {
        var self = this;

        this.setState({ isValid : UserStore.getState().validDPHCredentials }, () => {
            self.getDPHUserCredentials();
        })
    }

    getDPHUserCredentials() {
        var self = this;

        AjaxPromises.POST(AuthEndPoints.GET_DPH_USER, UserStore.getApiData())
        .then(res => {
            self.setState({ loading : false });
            var user = res.Data || {};
            self.setState({
                isSetUp : true,
                isEnabled : user.IsEnabled,
                name : user.Name,
                username : user.Username,
                password : user.Password,
                override: user.ManagerOverrideEnabled
            });
        });
    }

    override() {
        var self = this;

        AjaxPromises.POST(UserEndPoints.CHECK_PIN_NUMBER, UserStore.getApiData({
            PinCode : this.state.managerPin
        })).then(res => {
            self.setState({ managerPin : '' }, () => {
                if (res.Data[0].MgrPermission === true) {
                    AjaxPromises.POST(AuthEndPoints.ENABLE_MANAGER_OVERRIDE, UserStore.getApiData()).then(res => {
                        if(res.Result) {
                            NotificationActions.success('DPH Override Enabled');
                            UserActions.checkDPHCredentials(this.props.selectedLocation.LocId, true);
                            self.setState({ override: true });
                        }
                    });
                }
                else {
                    NotificationActions.alert('Invalid Manager PIN');
                }
            })
        });
    }

    disableOverride() {
        var self = this;

        AjaxPromises.POST(AuthEndPoints.DISABLE_MANAGER_OVERRIDE, UserStore.getApiData()).then(res => {
            if(res.Result) {
                NotificationActions.success('DPH Override disabled');
                UserActions.checkDPHCredentials(this.props.selectedLocation.LocId, true);
                self.setState({ override: false });
            }
        });
    }

    update() {
        var self = this;

        AjaxPromises.POST(AuthEndPoints.SET_DPH_USER, UserStore.getApiData({
            DPHUserId: this.props.user.userId,
            Username: this.state.username,
            Password: this.state.password,
            IsEnabled: this.state.isEnabled
        })).then(res => {
            if (res.Result){
                NotificationActions.success('DPH User Updated')
                UserActions.checkDPHCredentials(this.props.selectedLocation.LocId, true);
            }
        });
    }

    render() {
        if(this.props.page !== 'dph-settings') {
            return null;
        }        

        return (
            <div className='settings'>
                <div className='container'>
                    <PageHeader title='MassCIP Credentials' />

                    <PageRow title='Username'>
                        <Input
                            value={this.state.username}
                            onChange={username => { this.setState({ username }); }} />
                    </PageRow>

                    <PageRow title='Password'>
                        <Input
                            type='password'
                            value={this.state.password}
                            onChange={password => { this.setState({ password }); }} />
                    </PageRow>
                    <PageRow>
                        <div
                            className='btn-green'
                            style={{'marginRight':20}}
                            onClick={this.update}
                        >
                            Update
                        </div>
                        {
                        !this.state.override &&
                        <div
                            className='btn-green'
                            onClick={() => { UserActions.checkDPHCredentials(this.props.selectedLocation.LocId, true); }}
                        >
                            Validate
                        </div>
                        }

                    </PageRow>

                    <PageHeader title='Manager Override to Use Master Credentials' />

                    <PageRow title='Manager PIN'>
                        <Input
                            type='password'
                            disabled={this.state.override}
                            value={this.state.managerPin}
                            onChange={managerPin => { this.setState({ managerPin }); }} />
                    </PageRow>

                    <PageRow>
                        { !this.state.override ?
                            <div
                                className='btn-green'
                                onClick={this.override}
                                style={{'marginRight':20}}
                            >

                                Override
                            </div>
                        :
                            <div
                                className='btn-green'
                                onClick={this.disableOverride}
                                style={{'marginRight':20}}
                                >

                                Disable Override
                            </div>
                        }
                        {
                        this.state.override &&
                        <div
                            className='btn-green'
                            onClick={() => { UserActions.checkDPHCredentials(this.props.selectedLocation.LocId, true); }}
                        >
                            Validate
                        </div>
                        }

                    </PageRow>
                </div>
            </div>
        );
    }
}

export default GLSettingsVG;


/*





*/


// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/settings/GLSettingsDPH.react.jsx